import React, { useContext, useState,useRef } from "react";

//axios and base url
import axios from "axios";
import { BASE_URL } from "../../../../../BaseUrl";

//functions
import {
  _t,
  getCookie,
  getSystemSettings,
  formatPrice,
  customStyle
} from "../../../../../functions/Functions";
import { useTranslation } from "react-i18next";

//3rd party packages
import { Helmet } from "react-helmet";
import Select from "react-select";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import { useReactToPrint } from "react-to-print";
import moment from 'moment';
import Moment from "react-moment";
import ReactHTMLTableToExcel from "react-html-table-to-excel";
// import { MdDelete } from 'react-icons/md';
// import StockReport from "./StockReport";

//pages & includes
import AccountsSidebar from "../AccountsSidebar";

//context consumer
import { SettingsContext } from "../../../../../contexts/Settings";
import { RestaurantContext } from "../../../../../contexts/Restaurant";
import { UserContext } from "../../../../../contexts/User";
import CustomSpinLoader from "../../../../components/CustomSpinLoader";

const TrialBalanceReport = () => {
    const { t } = useTranslation();
    let { loading, setLoading, generalSettings } = useContext(SettingsContext);
    const { branchForSearch } = useContext(RestaurantContext);
    const { authUserInfo } = useContext(UserContext);

    //toast obj
    let common_toast={
      position: "bottom-center",
      autoClose: 10000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      className: "text-center toast-notification",
    }

    const [trialBalanceView, setTrialBalanceView] = useState(null);
    const [searchTrialBalanceView, setSearchTrialBalanceView] = useState({
      searched: false,
      list: [],
    });
    const isThrottled = useRef(false);

    //reportFields state
    const [reportFields,setReportFields]=useState({
      from_date:"",
      to_date:"",
      branch:"",
      type:"trial_balance"
    });

    //report states
    const [reportData, setReportData] = useState([]);
    const [generatedReport, setGeneratedReport] = useState(false);
    const [option,setOption] = useState("view");
    const [reportType,setReportType] = useState("with_zero");
    const componentRef = useRef();
    const componentRefThermal = useRef();

    const handleFromDate=(from_date)=>{
      setReportFields({
        ...reportFields,
        from_date
      })
    }

    const thermalPrint = useReactToPrint({
      content: () => componentRefThermal.current,
      pageStyle: `@page { size: landscape; margin: 5px; }`,
    });

    const handleOption  = (e) =>{
      setOption(e.target.value)
    }

    const handleToDate=(to_date)=>{
      setReportFields({
        ...reportFields,
        to_date
      })
    }

    const handleBranch=(branch)=>{
      setReportFields({
        ...reportFields,
        branch
      })
    }

    const handleSetType = (e)=>{
      setReportFields({
        ...reportFields,
        type: e.target.value
      })
    }

    const handleReportType  = (e) =>{
      setReportType(e.target.value)
    }

    //search account here
    const handleSearch = (e) => {
      let searchInput = e.target.value.toLowerCase();
      if (searchInput.length === 0) {
        setSearchTrialBalanceView({ ...searchTrialBalanceView, searched: false });
      } else {
        let searchedList = 
        // .filter((item) => {          
        //   let lowerCaseItemIdentity = item.DocumentIdentity && item.DocumentIdentity.toLowerCase();
        //   let lowerCaseItemAccount = item.AccountName.toLowerCase();
        //   let lowerCaseItemCheque = item.ChequeNo && item.ChequeNo.toLowerCase();
        //   return (lowerCaseItemIdentity && lowerCaseItemIdentity.includes(searchInput)) ||
        //   (lowerCaseItemAccount && lowerCaseItemAccount.includes(searchInput)) ||
        //   (lowerCaseItemCheque && lowerCaseItemCheque.includes(searchInput));
        // });
        trialBalanceView && Object.fromEntries(
          Object.entries(trialBalanceView).map(([key, arr]) => [
            key,
            arr.filter(item =>
              item.level3_display_nam.toLowerCase().includes(searchInput)
            ),
          ])
        );
        setSearchTrialBalanceView({ 
          ...searchTrialBalanceView,
          list: searchedList,
          searched: true,
        });
      }
    };

    const paginatedTrialBalance = (page)=>{
      if (isThrottled.current) {
        return;
      }
      isThrottled.current = true;
      setTimeout(() => {
        isThrottled.current = false;
      }, 3000);
      const url = BASE_URL + "/settings/get-trial-balance-report?=page="+page;
      let {from_date , to_date ,type, branch} = reportFields
      let formData = new FormData();
      formData.append('from_date', moment(from_date).format("YYYY-MM-DD"));
      formData.append('to_date', moment(to_date).format("YYYY-MM-DD"));
      formData.append('branch_id', branch ? branch.id : "");
      formData.append('type', type ? type : "");
      formData.append('report_type', reportType);

      return axios
      .post(url, formData, {
        headers: { Authorization: `Bearer ${getCookie()}` },
      })
      .then((res) => {
        setTrialBalanceView(res.data[1]);
        setLoading(false);
      })
      .catch((error) => {            
        setLoading(false);
        toast.error(`${_t(t("Please try again"))}`,common_toast);
      });
    }

    const handleSubmit=(e)=>{
      e.preventDefault();
      setReportData(null);
      setTrialBalanceView(null);
      setSearchTrialBalanceView({
        searched: false,
        list: [],
      })
      let {from_date , to_date ,type, branch} = reportFields;
      if (
        (authUserInfo.details.user_type === "staff" || authUserInfo.details.user_type === "manager") &&
        !branch?.id
      ) {
        toast.error(`${_t(t("Please select branch"))}`, {
          position: "bottom-center",
          closeButton: false,
          autoClose: 10000,
          hideProgressBar: false,
          closeOnClick: true,
          pauseOnHover: true,
          className: "text-center toast-notification",
        });
        return;
      }
      if((from_date !== "" && from_date !== null) && (to_date !== "" && to_date !== null)){
        // setLoading(true);
        if(option === "view"){
          paginatedTrialBalance(1)
        }else{
          const url = BASE_URL + "/settings/get-trial-balance-report";
          let formData = new FormData();
          formData.append('from_date', moment(from_date).format("YYYY-MM-DD"));
          formData.append('to_date', moment(to_date).format("YYYY-MM-DD"));
          formData.append('branch_id', branch ? branch.id : "");
          formData.append('type', type ? type : "");
          formData.append('report_type', reportType);
          setLoading(true)
          return axios
          .post(url, formData, {
            headers: { Authorization: `Bearer ${getCookie()}` },
          })
          .then((res) => {
            setReportData(res.data[0]);
            setGeneratedReport(true);
            if(option==="excel"){
              componentRef.current.handleDownload();            
            }else{
              thermalPrint()
            }
            setReportFields({
              ...reportFields,
              from_date:"",
              to_date:"",
            })
            setLoading(false);
          })
          .catch((error) => {            
            setLoading(false);
            toast.error(`${_t(t("Please try again"))}`,common_toast);
          });
        }
      }else{
        toast.error(`${_t(t("Please select from date & to date"))}`,common_toast);
      }
    }

    let g_totalCurrDebit = 0;
    let g_totalCurrCredit = 0;
    let g_totalOpDebit = 0;
    let g_totalOpCredit = 0;
    let g_totalDebit = 0;
    let g_totalCredit = 0;

    const resetTotal = ()=>{
      g_totalCurrDebit = 0;
      g_totalCurrCredit = 0;
      g_totalOpDebit = 0;
      g_totalOpCredit = 0;
      g_totalDebit = 0;
      g_totalCredit = 0;
    }

    let currDebit = 0;
    let  currCredit = 0;
    let OpDebit = 0;
    let  OpCredit = 0;
    let totalDebit = 0;
    let  totalCredit = 0;

    const tableReturn = (accounts) => {
      return (
        <>
          {accounts.map((item, i) => {
            currDebit += item.cur_debit || 0;
            currCredit += item.cur_credit || 0;
            OpDebit += item.op_debit || 0;
            OpCredit += item.op_credit || 0;
            totalDebit += item.tot_debit || 0;
            totalCredit += item.tot_credit || 0;
            
            g_totalCurrDebit += item.cur_debit || 0;
            g_totalCurrCredit += item.cur_credit || 0;
            g_totalOpDebit += item.op_debit || 0;
            g_totalOpCredit += item.op_credit || 0;
            g_totalDebit += item.tot_debit || 0;
            g_totalCredit += item.tot_credit || 0;

            return (
              <tr key={i}>
                <td
                  scope="row"
                  className="sm-text text-capitalize align-middle border-1 border"
                >
                  {item.level3_display_nam}
                </td>

                {
                  reportFields.type !== "trial_balance_closing" && (
                    <>
                      <td
                        scope="row"
                        className="sm-text text-capitalize align-middle text-center border-1 border"
                      >
                        {formatPrice(item.op_debit)}
                      </td>
                      <td
                        scope="row"
                        className="sm-text text-capitalize align-middle text-center border-1 border"
                      >
                        {formatPrice(item.op_credit)}
                      </td>
                      <td
                        scope="row"
                        className="sm-text text-capitalize align-middle text-center border-1 border"
                      >
                        {formatPrice(item.cur_debit) || 0}
                      </td>
                      <td
                        scope="row"
                        className="sm-text text-capitalize align-middle text-center border-1 border"
                      >
                        {formatPrice(item.cur_credit) || 0}
                      </td>
                    </>
                  )
                }
              
                <td
                  scope="row"
                  className="sm-text text-capitalize align-middle text-center border-1 border"
                >
                  {formatPrice(item.tot_debit)}
                </td>
                <td
                  scope="row"
                  className="sm-text text-capitalize align-middle text-center border-1 border"
                >
                  {formatPrice(item.tot_credit)}
                </td>
              </tr>
            );
          })}
        </>
      )
    }


  return (
    <>
    <Helmet>
      <title>{_t(t("Accounts Trial Balance Report"))}</title>
    </Helmet>

    <ReactHTMLTableToExcel
      id="test-table-xls-button"
      className="download-table-xls-button btn btn-success float-right mr-3 invisible"
      table="table-to-xls"
      filename="Trial Balance Report"
      sheet="sheet 1"
      buttonText="Report"
      ref={componentRef}
    />

    {/* Print Button */}
    <div className="d-none">
      <div>
        <div className="fk-print">
          <div className="container">
            <div className="row">
              <div className="col-12">
                {reportData !== null &&
                  reportData !== undefined &&
                  generatedReport === true && 
                  (
                    <>
                      <div className="row gx-2 justify-content-center t-pb-15 t-pt-15 report">
                        <div className="col-12 t-mb-15 mb-md-0 table-responsive">
                          <table
                            className="table table-bordered table-hover min-table-height mt-3"
                            id="table-to-xls"
                          >
                            <div className="page-break"></div>
                            <thead className="align-middle">
                              <tr style={{ border: "0px" }}>
                                <th colspan={reportFields.type === "trial_balance_closing" ? "3" : "7" } style={{ border: "0px" }}>
                                  <div className="row">
                                    <div className="col-12">
                                      <h3 className="text-center mb-0">
                                        {getSystemSettings(generalSettings, "siteName")}
                                      </h3>
                                      <h3 className="text-center mt-0">
                                        Accounts Trial Balance Report
                                      </h3>
                                      <p className="text-center">
                                        FROM&nbsp;
                                        <Moment format="LL">
                                          {reportFields.from_date}
                                        </Moment>
                                        &nbsp;TO&nbsp;
                                        <Moment format="LL">{reportFields.to_date}</Moment>
                                      </p>
                                    </div>
                                  </div>
                                </th>
                              </tr>
                              <tr>
                                <th></th>
                                {
                                  reportFields.type !== "trial_balance_closing" && (
                                  <>
                                    <th
                                      colSpan={2}
                                    >
                                      {_t(t("Opening"))}
                                    </th>
                                    <th
                                      colSpan={2}
                                    >
                                      {_t(t("Current"))}
                                    </th>
                                  </>)
                                }
                                <th
                                  colSpan={2}
                                >
                                  {_t(t("Closing"))}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  scope="col"
                                >
                                  {_t(t("Account Name"))}
                                </th>

                                {
                                  reportFields.type !== "trial_balance_closing" && (
                                    <>
                                      <th
                                        scope="col"
                                      >
                                        {_t(t("Debit"))}
                                      </th>
                                      
                                      <th
                                        scope="col"
                                      >
                                        {_t(t("Credit"))}
                                      </th>
                                      
                                      <th
                                        scope="col"
                                      >
                                        {_t(t("Debit"))}
                                      </th>

                                      <th
                                        scope="col"
                                      >
                                        {_t(t("Credit"))}
                                      </th>
                                    </>
                                  )
                                }
                                <th
                                  scope="col"
                                >
                                  {_t(t("Debit"))}
                                </th>
                               
                                <th
                                  scope="col"
                                >
                                  {_t(t("Credit"))}
                                </th>

                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {/* loop here*/}
                              {reportData &&
                                Object.keys(reportData).map(
                                  (group_name, index) => { 
                                    currDebit = 0;
                                    currCredit = 0;
                                    OpDebit = 0;
                                    OpCredit = 0;
                                    totalDebit = 0;
                                    totalCredit = 0; 

                                    return(
                                    <div key={index}>
                                      <tr>
                                        <td
                                          scope="row"
                                        >
                                          <b>{group_name}</b>
                                        </td>
                                      </tr>
                                      {
                                      Array.isArray(reportData[group_name]) ? 
                                        tableReturn(reportData[group_name])
                                      :
                                      Object.keys(reportData[group_name]).map((group)=>{
                                        return(
                                          <>
                                            <tr>
                                              <td
                                                scope="row"
                                              >
                                                <b>{group}</b>
                                              </td>
                                            </tr>
                                            {tableReturn(reportData[group_name][group])}
                                          </>
                                        )
                                      })
                                      }
                                      <tr>
                                        <td
                                          scope="row"
                                        >
                                          <b>{group_name}</b>
                                        </td>
                                        {
                                          reportFields.type !== "trial_balance_closing" && (
                                            <>
                                              <td
                                                scope="row"
                                              >
                                                <b>{formatPrice(OpDebit)}</b>
                                              </td>
                                              <td
                                                scope="row"
                                              >
                                                <b>{formatPrice(OpCredit)}</b>
                                              </td>
                                              <td
                                                scope="row"
                                              >
                                                <b>{formatPrice(currDebit)}</b>
                                              </td>
                                              <td
                                                scope="row"
                                              >
                                                <b>{formatPrice(currCredit)}</b>
                                              </td>
                                            </>
                                          )
                                        }
                                        <td
                                          scope="row"
                                        >
                                          <b>{formatPrice(totalDebit)}</b>
                                        </td>
                                        <td
                                          scope="row"
                                        >
                                          <b>{formatPrice(totalCredit)}</b>
                                        </td>
                                      </tr>
                                      <tr></tr>
                                    </div>
                                  );
                                })
                              }
                              <tr>
                                <td
                                  scope="row"
                                >
                                  <b>Total</b>
                                </td>
                                {
                                  reportFields.type !== "trial_balance_closing" && (
                                    <>
                                      <td
                                        scope="row"
                                      >
                                        <b>{formatPrice(g_totalOpDebit)}</b>
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        <b>{formatPrice(g_totalOpCredit)}</b>
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        <b>{formatPrice(g_totalCurrDebit)}</b>
                                      </td>
                                      <td
                                        scope="row"
                                      >
                                        <b>{formatPrice(g_totalCurrCredit)}</b>
                                      </td>
                                    </>
                                  )
                                }
                                <td
                                  scope="row"
                                >
                                  <b>{formatPrice(g_totalDebit)}</b>
                                </td>
                                <td
                                  scope="row"
                                >
                                  <b>{formatPrice(g_totalCredit)}</b>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </>
                  )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    {/* thermal print */}
    <div className="d-none">
      <div ref={componentRefThermal}>
        {          
          <div className="fk-print">
            <div className="container-fluid">
              <div className="row">
                <div className="col-12">
                  {/*Transaction of party wise report */}
                  <div className="col-12 mx-2">
                    {reportData !== null &&
                      reportData !== undefined &&
                      generatedReport === true && (
                        <>
                          <div className="row">
                            <h3 className="mt-3 fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                              {getSystemSettings(generalSettings, "siteName")}
                            </h3>
                            <h3 className="mt-1 fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                              Accounts Trial Balance Report
                            </h3>
                            <div>
                              <p className="mt-1 mb-0 fk-print-text_pos font-weight-bold text-uppercase text-center table-text">
                                FROM&nbsp;
                                <Moment format="LL">
                                  {reportFields.from_date}
                                </Moment>
                                &nbsp;TO&nbsp;
                                <Moment format="LL">{reportFields.to_date}</Moment>
                              </p>
                            </div>
                          </div> 
                          <table className="table table-bordered-sm w-100 mt-4 fk-print-text_pos">
                            <thead className="align-middle">
                              <tr>
                                <th></th>
                                {
                                  reportFields.type !== "trial_balance_closing" && (
                                  <>
                                    <th
                                      colSpan={2}
                                      className="sm-text text-capitalize align-middle text-center border-1 border "
                                    >
                                      {_t(t("Opening"))}
                                    </th>
                                    <th
                                      colSpan={2}
                                      className="sm-text text-capitalize align-middle text-center border-1 border "
                                    >
                                      {_t(t("Current"))}
                                    </th>
                                  </>)
                                }
                                <th
                                  colSpan={2}
                                  className="sm-text text-capitalize align-middle text-center border-1 border "
                                >
                                  {_t(t("Closing"))}
                                </th>
                              </tr>
                              <tr>
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle border-1 border "
                                  style={{minWidth:"7rem"}}
                                >
                                  {_t(t("Account Name"))}
                                </th>
                                {
                                  reportFields.type !== "trial_balance_closing" && (
                                    <>
                                      <th
                                        scope="col"
                                        className="sm-text text-capitalize align-middle text-center border-1 border "
                                      >
                                        {_t(t("Debit"))}
                                      </th>
                                      
                                      <th
                                        scope="col"
                                        className="sm-text text-capitalize align-middle text-center border-1 border "
                                      >
                                        {_t(t("Credit"))}
                                      </th>
                                      
                                      <th
                                        scope="col"
                                        className="sm-text text-capitalize align-middle text-center border-1 border "
                                      >
                                        {_t(t("Debit"))}
                                      </th>

                                      <th
                                        scope="col"
                                        className="sm-text text-capitalize align-middle text-center border-1 border "
                                      >
                                        {_t(t("Credit"))}
                                      </th>
                                    </>
                                   )
                                }
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border "
                                >
                                  {_t(t("Debit"))}
                                </th>
                              
                                <th
                                  scope="col"
                                  className="sm-text text-capitalize align-middle text-center border-1 border "
                                >
                                  {_t(t("Credit"))}
                                </th>
                              </tr>
                            </thead>
                            <tbody className="align-middle">
                              {resetTotal()}
                              {reportData &&
                                Object.keys(reportData).map((group_name) => {   
                                  currDebit = 0;
                                  currCredit = 0;
                                  OpDebit = 0;
                                  OpCredit = 0;
                                  totalDebit = 0;
                                  totalCredit = 0;

                                  return(
                                  <>
                                    <tr>
                                      <td
                                        className="sm-text text-capitalize align-middle border-1 border"
                                      >
                                        <b>{group_name}</b>
                                      </td>
                                      <th className="border-1 border" colspan="7">
                                      </th>
                                    </tr>
                                    {Array.isArray(reportData[group_name]) ? 
                                      tableReturn(reportData[group_name])
                                      :
                                      Object.keys(reportData[group_name]).map((group)=>{
                                      return(
                                        <>
                                          <tr>
                                            <td
                                              className="sm-text text-capitalize align-middle border-1 border"
                                            >
                                              <b>{group}</b>
                                            </td>
                                            <th className="border-1 border" colspan="7">
                                            </th>
                                          </tr>
                                          {tableReturn(reportData[group_name][group])}
                                        </>
                                      )
                                    })
                                    }
                                    <tr>
                                      <th
                                        scope="row"
                                        className="sm-text text-capitalize align-middle border-1 border"
                                      >
                                        <b>{group_name}</b>
                                      </th>
                                      {
                                        reportFields.type !== "trial_balance_closing" && (
                                          <>
                                          <td
                                            scope="row"
                                            className="sm-text text-capitalize align-middle text-center border-1 border"
                                          >
                                            <b>{formatPrice(OpDebit)}</b>
                                          </td>
                                          <td
                                            scope="row"
                                            className="sm-text text-capitalize align-middle text-center border-1 border"
                                          >
                                            <b>{formatPrice(OpCredit)}</b>
                                          </td>
                                          <td
                                            scope="row"
                                            className="sm-text text-capitalize align-middle text-center border-1 border"
                                          >
                                            <b>{formatPrice(currDebit)}</b>
                                          </td>
                                          <td
                                            scope="row"
                                            className="sm-text text-capitalize align-middle text-center border-1 border"
                                          >
                                            <b>{formatPrice(currCredit)}</b>
                                          </td>
                                          </>
                                        )
                                      }
                                      <td
                                        scope="row"
                                        className="sm-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <b>{formatPrice(totalDebit)}</b>
                                      </td>
                                      <td
                                        scope="row"
                                        className="sm-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <b>{formatPrice(totalCredit)}</b>
                                      </td>
                                    </tr>
                                    <tr></tr>
                                  </>
                                  );
                                })
                              } 
                              <tr>
                                <td
                                  scope="row"
                                >
                                  <b>Total</b>
                                </td>
                                {
                                  reportFields.type !== "trial_balance_closing" && (
                                    <>
                                      <td
                                        scope="row"
                                        className="sm-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <b>{formatPrice(g_totalOpDebit)}</b>
                                      </td>
                                      <td
                                        scope="row"
                                        className="sm-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <b>{formatPrice(g_totalOpCredit)}</b>
                                      </td>
                                      <td
                                        scope="row"
                                        className="sm-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <b>{formatPrice(g_totalCurrDebit)}</b>
                                      </td>
                                      <td
                                        scope="row"
                                        className="sm-text text-capitalize align-middle text-center border-1 border"
                                      >
                                        <b>{formatPrice(g_totalCurrCredit)}</b>
                                      </td>
                                    </>
                                  )
                                }
                                <td
                                  scope="row"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"
                                >
                                  <b>{formatPrice(g_totalDebit)}</b>
                                </td>
                                <td
                                  scope="row"
                                  className="sm-text text-capitalize align-middle text-center border-1 border"

                                >
                                  <b>{formatPrice(g_totalCredit)}</b>
                                </td>
                              </tr>                                 
                            </tbody>
                          </table>
                        </>
                    )}
                  </div>
                </div> 
              </div> 
            </div> 
          </div>           
        }
      </div> 
    </div>

    {/* main body */}
    <main id="main" data-simplebar>
      <div className="container-fluid">
        <div className="row t-mt-10 gx-2">
          {/* left Sidebar */}
          <div className="col-lg-2 col-xxl-2 t-mb-30 mb-lg-0">
            <AccountsSidebar />
          </div>
          {/* left Sidebar ends */}

          {/* Rightbar contents */}
          <div className="col-lg-10 col-xxl-10 t-mb-30 mb-lg-0">
            <div className="t-bg-white">
              <div
                className="fk-scroll--pos-menu table-bottom-info-hide"
                data-simplebar
              >
                <div className="t-pl-15 t-pr-15">
                  {/* next page data spin loading */}
                  <CustomSpinLoader loading={loading}/>
                  {/* spin loading ends */}

                  {/* Loading effect */}
                  {/* {loading === true ? (
                    tableLoading()
                  ) : ( */}
                    <div key="fragment-3">
                      <div className="row gx-2 align-items-center t-pt-15 t-pb-15 justify-content-between">
                        <div className="col-md-6 col-lg-5 t-mb-15 mb-md-0">
                          <ul className="t-list fk-breadcrumb">
                            <li className="fk-breadcrumb__list">
                              <span className="t-link fk-breadcrumb__link text-capitalize">
                                {_t(t("Trial Balance Report"))}
                              </span>
                            </li>
                          </ul>
                        </div>
                        <div className="col-6 d-flex justify-content-end p-0">
                          <div className="d-inline mr-3 d-flex align-items-center">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="view"
                              name="view"
                              value="view"
                              onChange={(e) => {
                                handleOption(e);
                              }}
                              checked={option === "view"}
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                              htmlFor="view"
                              style={{fontSize:"16px",borderRadius:"5px"}}
                            >
                              <i className="fa fa-eye" aria-hidden="true"></i> {_t(t("View"))}
                            </label>
                          </div>
                          <div className="d-inline mr-3 d-flex align-items-center">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="excel_report"
                              name="excel_report"
                              value="excel"
                              onChange={(e) => {
                                handleOption(e);
                              }}
                              checked={option === "excel"}
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                              htmlFor="excel_report"
                              style={{fontSize:"16px",borderRadius:"5px"}}
                            >
                              <i className="fa fa-table" aria-hidden="true"></i> {_t(t("Excel"))}
                            </label>
                          </div>

                          <div className="d-inline mr-2 d-flex align-items-center">
                            <input
                              type="radio"
                              className="form-check-input pointer-cursor"
                              id="print_report"
                              name="print_report"
                              value="print"
                              onChange={(e) => {
                                handleOption(e);
                              }}
                              checked={option === "print"}
                            />
                            <label
                              className="form-radio-label pointer-cursor ml-2 pt-1 text-primary"
                              htmlFor="print_report"
                              style={{fontSize:"16px",borderRadius:"5px"}}
                            >
                              <i className="fa fa-print" aria-hidden="true"></i> {_t(t("Print"))}
                            </label>
                          </div>
                        </div>
                      </div>
                      
                      <div className="card mx-1 px-2 pb-1">
                        {/* Form starts here */}
                        <form
                          className="row p-1 mx-0 mb-3 table-text"
                          onSubmit={handleSubmit}
                        >
                          <div className="col-12">
                            <div>                            
                              <div className="row">
                                <div className="form-group col-2 text-right mt-2">
                                  <div className="mb-2 text-left">
                                    <label
                                    htmlFor="fromDate"
                                    className="control-label"
                                    >
                                      {_t(t("From Date"))}
                                    <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <DatePicker
                                    selected={reportFields.from_date}
                                    onChange={(date) => handleFromDate(date)}
                                    maxDate={new Date()}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="form-control table-text d-block"
                                    placeholderText={_t(t("From Date"))}
                                    shouldCloseOnSelect={false}                                  
                                  />
                                </div>

                                <div className="form-group col-2 text-right mt-2">
                                  <div className="mb-2 text-left">
                                    <label
                                    htmlFor="toDate"
                                    className="control-label"
                                    >
                                      {_t(t("To Date"))}
                                    <span className="text-danger">*</span>
                                    </label>
                                  </div>
                                  <DatePicker
                                    selected={reportFields.to_date}
                                    onChange={(date) => handleToDate(date)}
                                    maxDate={new Date()}
                                    peekNextMonth
                                    showMonthDropdown
                                    showYearDropdown
                                    dropdownMode="select"
                                    className="form-control table-text d-block"
                                    placeholderText={_t(t("To Date"))}
                                    shouldCloseOnSelect={false}                                  
                                  />
                                </div>

                                <div className="form-group mt-2 col-2">
                                  <div className="mb-2 text-left">
                                    <label
                                      htmlFor="transaction"
                                      className="control-label"
                                    >
                                      {_t(t("Branch"))}                                  
                                    </label>
                                  </div>
                                  <Select
                                    options={branchForSearch ? branchForSearch : []}
                                    getOptionLabel={(option) => option.name}
                                    getOptionValue={(option) => option.id}
                                    value={reportFields.branch || ""}
                                    classNamePrefix="select table-text"
                                    onChange={(branch)=>handleBranch(branch)} 
                                    isClearable                               
                                    placeholder={
                                      _t(t("Select branch")) + ".."
                                    }
                                    styles={customStyle}
                                  />
                                </div>

                                <div className="col-2 mt-2">
                                  <div className="mt-3">
                                    <input
                                      type="radio"
                                      className="form-check-input pointer-cursor"
                                      id="trial_balance"
                                      name="trial_balance"
                                      value="trial_balance"
                                      onChange={(e) => handleSetType(e)}
                                      checked={reportFields.type === "trial_balance"}
                                    />
                                    <label
                                      className="form-radio-label pointer-cursor ml-2"
                                      htmlFor="trial_balance"
                                    >
                                      {_t(t("Trial Balance"))}
                                    </label>
                                  </div>

                                  <div className="mt-2">
                                    <input
                                      type="radio"
                                      className="form-check-input pointer-cursor"
                                      id="trial_balance_closing"
                                      name="trial_balance_closing"
                                      value="trial_balance_closing"
                                      onChange={(e) => handleSetType(e)}
                                      checked={reportFields.type === "trial_balance_closing"}
                                    />
                                    <label
                                      className="form-radio-label pointer-cursor ml-2"
                                      htmlFor="trial_balance_closing"
                                    >
                                      {_t(t("Balance Closing"))}
                                    </label>
                                  </div>
                                </div>
                                
                                <div className="col-2 mt-2">
                                  <div className="mt-3">
                                    <input
                                      type="radio"
                                      className="form-check-input pointer-cursor"
                                      id="showWithZero"
                                      name="showWithZero"
                                      value="without_zero"
                                      checked={reportType==="without_zero"}
                                      onChange={(e) => handleReportType(e)}
                                    />
                                    <label
                                      className="form-radio-label pointer-cursor ml-2"
                                      htmlFor="showWithZero"
                                    >
                                      {_t(t("Without Zero"))}
                                    </label>
                                  </div>

                                  <div className="mt-2">
                                    <input
                                      type="radio"
                                      className="form-check-input pointer-cursor"
                                      id="showWithZero_no"
                                      name="showWithZero"
                                      value="with_zero"
                                      checked={reportType==="with_zero"}
                                      onChange={(e) => handleReportType(e)}
                                    />
                                    <label
                                      className="form-radio-label pointer-cursor ml-2"
                                      htmlFor="showWithZero_no"
                                    >
                                      {_t(t("With Zero"))}
                                    </label>
                                  </div>
                                </div>

                                <div style={{textAlign:"right"}} className="form-group mt-2 col-2">                                                                                                                        
                                  <button
                                    disabled={loading}
                                    type="submit"
                                    className="btn btn-primary rounded mt-2"
                                  >
                                    <i className="fa fa-table" aria-hidden="true"></i> {_t(t("Print Trial"))}
                                  </button>                                                                                                                                                                                       
                                </div>
                              </div>
                            </div>                                                                        
                          </div>
                        </form>
                        {(trialBalanceView || (searchTrialBalanceView?.list && searchTrialBalanceView?.list?.length)) ? (
                          <div className="row">
                            <div className="col-12">
                              {/* <div className="d-flex justify-content-end mb-2">
                                <div className="form-file">
                                  <input
                                    type="text"
                                    className="form-control border-0 form-control--light-1 table-text rounded-sm"
                                    placeholder={_t(t("Search")) + ".."}
                                    onChange={handleSearch}
                                  />
                                </div>
                              </div> */}
                              {/*Transaction of party wise report */}
                              <div className="row gx-2 justify-content-center py-2 report  border border-1 rounded-sm">
                                <div className="col-12 t-mb-15 mb-md-0 bill_modal_scroll" style={{height: "calc(100vh - 19.1rem)"}}>
                                  <table className="table table-bordered my-1">
                                    <thead className="align-middle">
                                      <tr style={{position: "sticky", top: "-0.1px", backgroundColor: "white"}}>
                                        <th
                                          scope="col"
                                          className="sm-text text-capitalize align-middle text-center border-1 border "
                                          style={{minWidth:"12rem"}}
                                        >
                                          {_t(t("Account Name"))}
                                        </th>
                                        <th
                                          scope="col"
                                          className="sm-text text-capitalize align-middle text-center border-1 border "
                                        >
                                          {_t(t("Debit"))}
                                        </th>
                                      
                                        <th
                                          scope="col"
                                          className="sm-text text-capitalize align-middle text-center border-1 border "
                                        >
                                          {_t(t("Credit"))}
                                        </th>
                                      </tr>
                                    </thead>
                                    <tbody className="align-middle">
                                      {resetTotal()}
                                      {trialBalanceView ? (trialBalanceView?.length ?
                                          Array.isArray(trialBalanceView) ? 
                                            trialBalanceView.map((item,i)=>{
                                              return (
                                                <tr key={i}>
                                                  <td
                                                    scope="row"
                                                    className="sm-text text-center text-capitalize align-middle border-1 border"
                                                  >
                                                    {item.level3_display_nam}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                                  >
                                                    {formatPrice(item.tot_debit)}
                                                  </td>
                                                  <td
                                                    scope="row"
                                                    className="sm-text text-capitalize align-middle text-center border-1 border"
                                                  >
                                                    {formatPrice(item.tot_credit)}
                                                  </td>
                                                </tr>
                                              )
                                            })
                                            :
                                            Object.keys(trialBalanceView).map((group)=>{
                                            return(
                                              <>
                                                <tr>
                                                  <td
                                                    className="sm-text text-capitalize align-middle border-1 border"
                                                  >
                                                    <b>{group}</b>
                                                  </td>
                                                  <th className="border-1 border" colspan="4">
                                                  </th>
                                                </tr>
                                                {
                                                  trialBalanceView[group].map((item,i)=>{
                                                    return (
                                                      <tr key={i}>
                                                        <td
                                                          scope="row"
                                                          className="sm-text text-center text-capitalize align-middle border-1 border"
                                                        >
                                                          {item.level3_display_nam}
                                                        </td>
                                                        <td
                                                          scope="row"
                                                          className="sm-text text-capitalize align-middle text-center border-1 border"
                                                        >
                                                          {formatPrice(item.tot_debit)}
                                                        </td>
                                                        <td
                                                          scope="row"
                                                          className="sm-text text-capitalize align-middle text-center border-1 border"
                                                        >
                                                          {formatPrice(item.tot_credit)}
                                                        </td>
                                                      </tr>
                                                    )
                                                  })
                                                }
                                              </>
                                            )
                                          })
                                          : (
                                            <tr>
                                              <td colSpan={4} className="xsm-text text-capitalize align-middle text-center">
                                                {_t(t("No data available"))}
                                              </td>
                                            </tr>
                                          )
                                        ) : (
                                          // searchTrialBalanceView?.list?.length ? (
                                          //   Array.isArray(searchTrialBalanceView?.list) ? 
                                          //   tableReturn(searchTrialBalanceView?.list)
                                          //   :
                                          //   Object.keys(searchTrialBalanceView?.list).map((group)=>{
                                          //   return(
                                          //     <>
                                          //       <tr>
                                          //         <td
                                          //           className="sm-text text-capitalize align-middle border-1 border"
                                          //         >
                                          //           <b>{group}</b>
                                          //         </td>
                                          //         <th className="border-1 border" colspan="7">
                                          //         </th>
                                          //       </tr>
                                          //       {tableReturn(searchTrialBalanceView?.list[group])}
                                          //     </>
                                          //   )})
                                          // ) : (
                                          //   <tr>
                                          //     <td colSpan={9} className="xsm-text text-capitalize align-middle text-center">
                                          //       {_t(t("No data available"))}
                                          //     </td>
                                          //   </tr>
                                          // )
                                          ""
                                        )
                                      } 
                                    </tbody>
                                  </table>
                                </div>  
                              </div>
                            </div> 
                          </div> 
                         ): ""
                        }
                      </div>
                    </div>
                </div>
              </div>
            </div>
          </div>
          {/* Rightbar contents end*/}
        </div>
      </div>
    </main>
      {/* main body ends */}
  </>
  )
}

export default TrialBalanceReport;
